module.exports = __webpack_public_path__ + "img/testPhone_b.39f109c6.png";